import { render, staticRenderFns } from "./AuthLoadingScreen.vue?vue&type=template&id=5bd9d14d&scoped=true&"
import script from "./AuthLoadingScreen.vue?vue&type=script&lang=js&"
export * from "./AuthLoadingScreen.vue?vue&type=script&lang=js&"
import style0 from "./AuthLoadingScreen.vue?vue&type=style&index=0&id=5bd9d14d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9d14d",
  null
  
)

export default component.exports